module.exports = __webpack_public_path__ + "img/product-no-photo.9e3f64ea.jpeg";